<button class="h3-bold"
        uiAccordionTrigger
        uiButton>
    <ng-content select="[heading]"></ng-content>
    @if (icon()) {
    <i class="icon-chevron-down-24"
       aria-hidden="true"></i>
    }
</button>
<div uiAccordionContent>
    <div class="p1 _content">
        <ng-content />
    </div>
</div>